import { mountVueWithProps } from '../common/utils/vue';
import RegistrationButtons from '../registration/RegistrationButtons';

document.querySelectorAll('.js-registration-buttons').forEach(element => {
  document.addEventListener('DOMContentLoaded', () => {
    mountVueWithProps({
      element: element,
      component: RegistrationButtons
    });
  });
});
